// 2026-05-01 [4] Recipe 합의 — recipe_miss 배너.
//
// sale_event.status='recipe_miss' (= 메뉴는 팔렸으나 recipe 0건 = stock 정합 깨짐) 카운트.
// 사용자 결정: "Recipe 미스 = sale_event.status='recipe_miss' + /ops 카운트·배너 alert".
// /ops 페이지 상단에 노출. count > 0 시만 보임. 클릭 = /settings/recipes/menus 로 이동.

import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '../primitives';
import { useRecipeMiss } from './queries';
import type { AnalyticsScope } from './queries';

export function RecipeMissBanner({ scope }: { scope: AnalyticsScope }) {
  const navigate = useNavigate();
  const q = useRecipeMiss(scope);
  const count = q.data?.count ?? 0;

  // count 0 또는 로딩 중 = 미노출 (CLS 방지를 위해 placeholder 도 X).
  if (q.isLoading || count <= 0) return null;

  const samples = q.data?.samples ?? [];
  const sampleLabel =
    samples.length > 0
      ? samples
          .slice(0, 2)
          .map((s) => s.storeName ?? '(매장 미확인)')
          .join(', ')
      : '';

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '12px 16px',
        background: 'var(--warning-bg, #FFF4E5)',
        border: '1px solid var(--warning-border, #FFB74D)',
        borderRadius: 'var(--radius-md, 8px)',
        color: 'var(--warning-strong, #B26A00)',
      }}
    >
      <Icon name="alert" size={18} color="var(--warning-strong, #B26A00)" />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.4 }}>
          레시피 미입력 메뉴 판매: {count}건
        </div>
        <div
          style={{
            fontSize: 12,
            color: 'var(--fg-2)',
            marginTop: 2,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          메뉴-재료 매핑이 없어 stock 차감이 누락되었습니다.
          {sampleLabel ? ` 최근 매장: ${sampleLabel}` : ''}
        </div>
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => navigate('/settings/recipes/menus')}
      >
        메뉴로 이동
      </Button>
    </div>
  );
}
